import SquaberTooltip from "../../../../../common/SquaberTooltip";
import React from "react";
import withTranslations from "../../../../../../../hocs/withTranslations";
import "./styles.scss";
import FormatCurrency from "../../../Homepage/components/FormatCurrency";

const PaymentBarTooltip = ({
  prorationAmount,
  affiliationDiscountAmount,
  discountAmount,
  subtractedAmount,
  renderRawContent = false,
  translate,
  locale
}) => {
  const hasProrationAmount = Number(prorationAmount) > 0;
  const hasAffiliationDiscountAmount = Number(affiliationDiscountAmount) > 0;
  const hasDiscountAmount = Number(discountAmount) > 0;

  const content =
    hasProrationAmount || hasAffiliationDiscountAmount || hasDiscountAmount ? (
      <div className={"payment-bar-tooltip"}>
        <ul className={"text-xs.3 text-white"}>
          {hasProrationAmount ? (
            <li>
              {translate("plans_payment-bar_tooltip_paid-amount")}
              <strong>{` -${FormatCurrency({
                value: prorationAmount,
                locale: locale
              })}`}</strong>
            </li>
          ) : null}
          {hasAffiliationDiscountAmount ? (
            <li>
              {translate(
                "plans_payment-bar_tooltip_affiliation-discount-amount"
              )}
              <strong>{` -${FormatCurrency({
                value: affiliationDiscountAmount,
                locale: locale
              })}`}</strong>
            </li>
          ) : null}
          {hasDiscountAmount ? (
            <li>
              {translate("plans_payment-bar_tooltip_discount-amount")}
              <strong>{` -${FormatCurrency({
                value: discountAmount,
                locale: locale
              })}`}</strong>
            </li>
          ) : null}
        </ul>
        {subtractedAmount ? (
          <strong className={"sum"}>
            {`${translate(
              "plans_payment-bar_tooltip_subtracted-amount"
            )} ${FormatCurrency({
              value: subtractedAmount,
              locale: locale
            })}`}
          </strong>
        ) : null}
      </div>
    ) : null;

  if (renderRawContent) {
    return content;
  }

  return content ? (
    <SquaberTooltip rawTitle={content}>
      <span className={"payment-bar-tooltip-icon"}>
        <i className="fa fa-info-circle"></i>
      </span>
    </SquaberTooltip>
  ) : null;
};

export default withTranslations(PaymentBarTooltip);
